import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench, Phone, Mail, MapPin } from 'lucide-react';
import type { FooterProps } from '../../types/ui';

export default function Footer({ showSocialLinks = true }: FooterProps) {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center space-x-2">
              <Wrench className="h-8 w-8 text-blue-400" />
              <span className="text-xl font-bold">Parakh Services</span>
            </Link>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <nav className="space-y-2">
              <Link to="/services" className="block hover:text-blue-400">Services</Link>
              <Link to="/locations" className="block hover:text-blue-400">Locations</Link>
              <Link to="/brands" className="block hover:text-blue-400">Brands</Link>
              <Link to="/blog" className="block hover:text-blue-400">Blog</Link>
            </nav>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-2">
              <a href="tel:+918559929954" className="flex items-center hover:text-blue-400">
                <Phone className="h-5 w-5 mr-2" />
                +91 8559929954
              </a>
              <a href="mailto:contact@parakhservices.com" className="flex items-center hover:text-blue-400">
                <Mail className="h-5 w-5 mr-2" />
                contact@parakhservices.com
              </a>
            </div>
          </div>

          {showSocialLinks && (
            <div>
              <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
              <div className="flex space-x-4">
                {/* Add social media links here */}
              </div>
            </div>
          )}
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Parakh Services. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}